<template>
  <div>
    <van-nav-bar
      fixed
      z-index="99"
      title="应用管理"
      left-arrow
      @click-left="onClickLeft"
    />
    <div style="margin-top: 96px">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="value1"
          @change="handleChoose"
          :options="class_list"
        />
        <div class="batch">
          <span @click="handleBatch"> {{ title }}</span>
        </div>
      </van-dropdown-menu>
      <div v-if="!list.length" class="none">
        <div><van-icon name="warning-o" /></div>
        暂无数据
      </div>
      <van-checkbox-group
        v-else
        v-model="result"
        ref="checkboxGroup"
        style="margin-bottom: 70px"
        @change="handlechecked"
      >
        <van-cell-group>
          <van-cell
            v-for="(item, index) in list"
            clickable
            :key="index"
            :title="item.app_name"
          >
            <template #icon>
              <van-checkbox
                v-if="isbatch"
                :name="item"
                ref="checkboxes"
                @click="toggle(item, index)"
                style="margin-right: 8px"
              />
              <img
                v-if="item.app_image"
                :src="item.app_image"
                width="40px"
                height="40px"
                alt=""
                style="vertical-align: middle; margin-right: 8px"
              />
              <img
                v-else
                src="../../assets/faxianxz.png"
                width="40px"
                height="40px"
                alt=""
                style="vertical-align: middle; margin-right: 8px"
              />
            </template>
            <template #right-icon>
              <van-switch
                v-model="item.checked"
                size="16px"
                @change="handleSwitch(item)"
                style="margin: 8px"
                active-color="#24db5a"
              />
              <van-button
                v-if="item.pat_status == 1"
                class="delete"
                plain
                @click="handleDel(item)"
                type="info"
                >卸载</van-button
              >
              <van-button
                v-else
                class="delete"
                plain
                @click="handleAdd(item)"
                type="info"
                >恢复</van-button
              >
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="footer" v-if="isbatch">
        <span
          >已选<span
            style="
              margin: 0 4px;
              width: 38px;
              display: inline-block;
              text-align: center;
            "
            >{{ checkedArr.length }}</span
          >应用</span
        >
        <span @click="checkAll">{{ allcheck }}</span>
        <van-button size="mini" plain type="info" @click="handleEnable"
          >启用</van-button
        >
        <van-button size="mini" plain type="info" @click="handleDisable"
          >禁用</van-button
        >
        <van-button size="mini" plain type="info" @click="handleUninstall"
          >卸载</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import URL from "../../api/index";
import qs from "qs";
import { Switch } from "vant";
import { Toast } from "vant";
import { Dialog } from "vant";
import { Button } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
Vue.use(Toast);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Switch);
Vue.use(Button);
export default {
  data() {
    return {
      title: "批量管理",
      allcheck: "全选",
      checked: true,
      list: ["a", "b", "c", "d", "e", "f", "g"],
      result: [],
      checkedArr: [],
      appid: [],
      value1: 0,
      isbatch: false,
      class_list: [
        { text: "全部班级", value: 0 },
        { text: "一年级十一班", value: 1 },
        { text: "四年级一班", value: 2 },
      ],
      class_id:0
    };
  },
  mounted() {
    this.handleclick();
    this.handleChoose(0);
  },
  methods: {
    // 班级列表
    handleclick() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$axios({
        method: "post",
        url: URL.getapp_class,
        data: {
          token: userInfo.token,
        },
      }).then((res) => {
        if (res.data.state == 0) {
          this.class_list = res.data.result;
          this.class_list.forEach((item, index) => {
            item.text = item.grade_name + item.class_name;
            item.value = item.class_id;
          });
          this.class_list.unshift({ text: "全部班级", value: 0 });
        }
      });
    },
    // 班级下拉框
    handleChoose(i) {
      this.class_id = i
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$axios({
        method: "post",
        url: URL.get_class_app,
        data: {
          token: userInfo.token,
          class_id: i,
        },
      }).then((res) => {
        if (res.data.state == 0) {
          // 退出全选功能
          this.title = "批量管理";
          this.isbatch = false;
          // 列表赋值
          this.list = res.data.result;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].status == 1) {
              this.list[i].checked = true;
            } else {
              this.list[i].checked = false;
            }
          }
        }
      });
    },
    // 复选框
    toggle(item, index) {
      this.$refs.checkboxes[index].toggle();
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    handleDel(item) { //卸载
      Dialog.confirm({
        message: "确认卸载该应用吗？",
      })
        .then(() => {
          this.handelmanage(item.app_id, "delete");
          // Toast("卸载成功");
          // 批量管理时 单个操作之后 取消所有选中项
          this.$refs.checkboxGroup.toggleAll(false);
        })
        .catch(() => {});
    },
    handleAdd(item){ // 恢复
      Dialog.confirm({
        message: "确认恢复该应用吗？",
      }).then(() => {
        this.hanaddmanage(item.app_id);
        // Toast("恢复成功");
        // 批量管理时 单个操作之后 取消所有选中项
        this.$refs.checkboxGroup.toggleAll(false);
      })
      .catch(() => {});
    },
    handleSwitch(item) {
      if (item.status == 1) {
        this.handelmanage(item.app_id, "forbid");
        Toast("禁用");
      } else {
        this.handelmanage(item.app_id, "start");
        Toast("启用");
      }
      // 批量管理时 单个操作之后 取消所有选中项
      this.$refs.checkboxGroup.toggleAll(false);
    },
    // 应用管控
    handelmanage(n, m) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$axios({
        method: "post",
        url: URL.get_app_control,
        data: {
          token: userInfo.token,
          class_id: this.class_id,
          app_id: n,
          type: m,
        },
      }).then((res) => {
        console.log(res);
        console.log(this.class_id);
        if (res.data.state == 0) {
          this.handleChoose(this.class_id);
          //  Toast("操作成功");
        }
      });
    },
    hanaddmanage(n){
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$axios({
        method: "post",
        url: URL.class_recover_app,
        data: {
          token: userInfo.token,
          class_id: this.class_id,
          app_id: n,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.state == 0) {
          this.handleChoose(this.class_id);
          //  Toast("操作成功");
        }
      });
    },
    // 全选
    checkAll() {
      if (this.allcheck == "全选") {
        this.allcheck = "取消";
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.allcheck = "全选";
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    // 批量管理
    handleBatch() {
      if (this.list.length) {
        if (this.title == "批量管理") {
          this.title = "完成";
          this.isbatch = true;
          this.allcheck = "全选";
          this.$refs.checkboxGroup.toggleAll(false);
        } else {
          this.title = "批量管理";
          this.isbatch = false;
          this.allcheck = "全选";
          this.$refs.checkboxGroup.toggleAll(false);
        }
      }
    },
    // 复选框组-- 批量操作
    handlechecked(arr) {
   
      this.checkedArr = arr;
      this.appid = [];
      arr.forEach((item) => {
        this.appid.push(item.app_id);
      });
    
    },
    handleUninstall() {
      if (this.checkedArr.length) {
        Dialog.confirm({
          title: "全部卸载",
          message: "确认卸载所选应用吗？",
        })
          .then(() => {
            this.handelmanage(this.appid, "delete");
            Toast("卸载成功");
            this.allcheck = "全选";
            this.$refs.checkboxGroup.toggleAll(false);
          })
          .catch(() => {});
      } else {
        Toast("请先选择要操作的应用");
      }
    },
    handleDisable() {
      if (this.checkedArr.length) {
        Dialog.confirm({
          title: "全部禁用",
          message: "确认禁用所选应用吗？",
        })
          .then(() => {
            this.handelmanage(this.appid, "forbid");
            Toast("禁用成功");
            this.allcheck = "全选";
            this.$refs.checkboxGroup.toggleAll(false);
          })
          .catch(() => {});
      } else {
        Toast("请先选择要操作的应用");
      }
    },
    handleEnable() {
      if (this.checkedArr.length) {
        Dialog.confirm({
          title: "全部启用",
          message: "确认启用所选应用吗？",
        })
          .then(() => {
            this.handelmanage(this.appid, "start");
            Toast("启用成功");
            this.allcheck = "全选";
            this.$refs.checkboxGroup.toggleAll(false);
          })
          .catch(() => {});
      } else {
        Toast("请先选择要操作的应用");
      }
    },
  },
};
</script>
<style scoped >
.van-dropdown-menu /deep/{
      position: fixed;
    top: 45px;
    z-index: 3;
    width: 100%;
}
.van-dropdown-menu /deep/.van-dropdown-menu__title {
  font-size: 14px !important;
}
.batch {
  width: 245px;
  text-align: right;
  font-size: 14px;
  line-height: 51px;
  margin-right: 20px;
}
.footer {
  width: 100%;
  height: 50px;
  background-color: #fff;
  line-height: 50px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  box-shadow: 0 -2px 3px -1px rgb(223, 223, 243);
}

.footer span {
  margin: 0 18px;
}
.footer .van-button {
  width: 40px;
  font-size: 12px;
  height: 20px;
  padding: 0;
  line-height: 10px;
}
.footer .van-button span {
  margin: 0 !important;
}
.van-cell__title {
  padding-top: 5px;
}
.delete {
  width: 40px;
  font-size: 12px;
  height: 20px;
  padding: 0;
  line-height: 10px;
  margin-top: 5px;
  border-radius: 10px;
  color: #ff2e2e !important;
  border: solid 1px #ff2e2e;
}
.none {
  margin-top: 100px;
  text-align: center;
  color: rgb(151, 151, 151);
  font-size: 28px;
}
.none .van-icon {
  font-size: 40px;
}
.van-cell .van-cell__title span {
  width: 170px;
  height: 30px;
  display: inline-block;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
</style>



// WEBPACK FOOTER //
// src/pages/management/management.vue